module.exports = __webpack_public_path__ + "img/tree-09-a-trunk.60c07207.png";